import { BaseOrderItem, OrderItemTypes, OrderItemProduct } from '.';

export class AddOn extends BaseOrderItem implements OrderItemProduct {
  public type = OrderItemTypes.add_on;
}
